<template>
    <div class="table-container">
        <!-- 搜索区域 -->

        <div style="display: flex;">
            <div style="margin-right: 10px;">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addPageHandle">新增</el-button>
            </div>

            <div class="search-container">

                <el-input v-model="searchKeyword" :placeholder="placeholder" clearable size="small"
                    prefix-icon="el-icon-search" @keyup.enter.native="handleSearch" style="width: 400px">
                    <el-button slot="append" icon="el-icon-search" size="small" @click="handleSearch"></el-button>
                </el-input>
            </div>
        </div>


        <!-- 表格主体 -->
        <el-table v-loading="loading" :data="tableData" height="580" @selection-change="handleSelectionChange"
            :header-cell-style="tableHeaderStyle">
            <!-- 复选框列（可选） -->
            <!-- <el-table-column type="selection" width="55" v-if="showSelection"></el-table-column> -->

            <!-- 序号列（可选） -->
            <el-table-column type="index" label="序号" align="center" width="50" v-if="showIndex"></el-table-column>

            <!-- 动态渲染列 -->
            <el-table-column v-for="(col, index) in columns" :key="col.prop + '1'" :prop="col.prop" :label="col.label"
                :width="col.width" align="center" :formatter="col.formatter">
                <!-- <template slot-scope="scope" v-if="col.slot">
                    <slot :name="col.slot" :row="scope.row"></slot>
                </template> -->
            </el-table-column>

            <!-- 操作列 -->
            <el-table-column ref="actionColumn" label="操作" fixed="right" :width="actionColumnWidth" align="center"
                v-if="actions.length > 0">
                <template slot-scope="scope">
                    <div class="action-btn">
                        <el-button v-for="(action, idx) in filterVisibleActions(scope.row)" :key="idx"
                            :type="action.type || 'text'" :size="action.size || 'mini'" :icon="action.icon"
                            :disabled="action.disabled && action.disabled(scope.row)"
                            :loading="action.loading && action.loading(scope.row)"
                            @click="handleAction(action, scope.row)"
                            :style="{ marginRight: idx < filterVisibleActions(scope.row).length - 1 ? '5px' : '0', color: action.color || '' }">
                            {{ action.text }}
                        </el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination" v-if="showPagination">
            <el-pagination :current-page="pagination.currentPage" :page-size="pagination.pageSize"
                :total="pagination.total" :page-sizes="pagination.pageSizes"
                layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TableComponent',
    props: {
        // 表格数据
        tableData: {
            type: Array,
            default: () => []
        },
        // 加载状态
        loading: {
            type: Boolean,
            default: false
        },
        // 列配置
        columns: {
            type: Array,
            default: () => []
            // 列配置项格式：{ prop, label, width, align, formatter, slot }
            // prop: 字段名，label: 列标题，width: 宽度，formatter: 格式化函数，slot: 自定义插槽名
        },
        // 操作按钮配置
        actions: {
            type: Array,
            default: () => [],
            // 操作配置项格式：{ text, type, size, icon, disabled(row), loading(row), handle(row) }
        },
        // 是否显示复选框
        // showSelection: {
        //     type: Boolean,
        //     default: true
        // },
        // 是否显示序号
        showIndex: {
            type: Boolean,
            default: false
        },
        // 是否显示分页
        showPagination: {
            type: Boolean,
            default: true
        },
        // 分页配置
        pagination: {
            type: Object,
            default: () => ({
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageSizes: [10, 20, 50, 100]
            })
        },
        // 操作列宽度
        // actionColumnWidth: {
        //     type: Number,
        //     default: 200
        // },

        placeholder: {
            type: String,
            default: '请输入标题搜索'
        }
    },

    data() {
        return {
            searchKeyword: '',
            actionColumnWidth: 100, // 初始宽度
        };
    },

    computed: {
        tableHeaderStyle() {
            return {
                'background-color': '#eaeaea',
                'color': '#333',
                'font-weight': '500',
            }
        },

    },

    watch: {
        // 监听表格数据变化，重新计算宽度
        tableData: {
            handler() {
                this.$nextTick(() => { // 确保DOM已更新
                    this.calcActionColumnWidth();
                });
            },
            deep: true,
        },
    },

    methods: {

        filterVisibleActions(row) {
            return this.actions.filter(action => {
                return !action.visible || action.visible(row);
            });
        },
        // 复选框选择变化
        handleSelectionChange(selection) {
            this.$emit('selection-change', selection);
        },
        // 操作按钮点击
        handleAction(action, row) {
            if (action.handle) {
                action.handle(row); // 执行按钮配置中的处理函数
            }
            this.$emit('action-click', action, row); // 同时向外触发事件
        },
        // 分页大小变化
        handleSizeChange(pageSize) {
            this.$emit('pagination-change', {
                ...this.pagination,
                pageSize,
                currentPage: 1 // 页码重置为1
            });
        },
        // 页码变化
        handleCurrentChange(currentPage) {
            this.$emit('pagination-change', {
                ...this.pagination,
                currentPage
            });
        },

        // 搜索处理
        handleSearch() {
            this.$emit('search', this.searchKeyword.trim());
            this.$emit('pagination-change', {
                ...this.pagination,
                currentPage: 1
            });
        },

        // 新增
        addPageHandle() {
            this.$emit('addPage');
        },

        // 计算操作列所需宽度
        calcActionColumnWidth() {
            const actionContainers = document.querySelectorAll('.action-btn');
            if (!actionContainers.length) return;

            let maxWidth = 0;
            actionContainers.forEach(container => {
                const width = container.offsetWidth;
                if (width > maxWidth) maxWidth = width;
            });

            this.actionColumnWidth = maxWidth + 20;
        },
    }
};
</script>

<style scoped>
.table-container {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}

.pagination {
    margin-top: 15px;
    text-align: right;
}

/* 搜索框样式 */
.search-container {
    margin-bottom: 15px;
    text-align: left;
    /* 左对齐 */

    ::v-deep(.el-input-group__append) {
        background-color: #409EFF;
        color: #fff;
        border: 1px solid #409EFF;
    }

    ::v-deep(.el-input__inner) {
        border: 1px solid #409EFF;
    }

    ::v-deep(.el-table .el-table__cell) {
        color: #000;
    }
}

.action-btn {
    display: flex;
    /* 按钮横向排列，确保宽度计算准确 */
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    /* 避免按钮换行 */
}
</style>